import { TAB_KEYS_BY_PAGE } from "@/const/tab.constants"
import { isSelfHosted } from "@/helpers/self-hosted.helper"

import type { Permission } from "@/domain/user"
import type { TFunction } from "@/hooks/useTranslation"

export const getItems = (t: TFunction) => {
  const TAB_KEYS = TAB_KEYS_BY_PAGE.SETTINGS

  return [
    { label: t("sections.organization") },
    {
      label: t("auth.title"),
      key: TAB_KEYS[2],
      permission: {
        resource: "settings.auth",
        action: "read"
      } as Permission
    },
    { label: t("users.title"), key: TAB_KEYS[0] },
    { label: t("sections.kai") },
    {
      label: t("kai.title"),
      key: TAB_KEYS[10],
      permission: {
        resource: "settings.kai-configurations",
        action: "write"
      } as Permission
    },
    {
      label: t("kai-guidance.title"),
      key: TAB_KEYS[12],
      permission: {
        resource: "settings.kai-configurations",
        action: "write"
      } as Permission
    },
    { label: t("sections.preferences") },
    { label: t("scopes.title"), key: TAB_KEYS[1] },
    {
      label: t("labels.title"),
      key: TAB_KEYS[9],
      permission: {
        resource: "settings.labels",
        action: "read"
      } as Permission
    },
    {
      label: t("sections.sast"),
      key: TAB_KEYS[8],
      permission: {
        resource: "settings.code-scan",
        action: "read"
      } as Permission
    },
    { label: t("sections.keys") },
    { label: t("apikeys.title"), key: TAB_KEYS[4] },
    {
      label: t("deploymentkeys.title"),
      key: TAB_KEYS[5],
      permission: {
        resource: "settings.deployment-keys",
        action: "read"
      } as Permission
    },
    {
      label: t("servicekeys.title"),
      key: TAB_KEYS[6],
      permission: {
        resource: "settings.service-keys",
        action: "read"
      } as Permission
    },
    { label: t("sections.system") },
    {
      label: t("system.title"),
      key: TAB_KEYS[11],
      externalLink: "https://status.kodemsecurity.com/"
    }
  ]
}

export const filterItems = <
  T extends { key?: string; permission?: Permission }
>(
  items: T[],
  hasPermission: (permission: Permission) => boolean | undefined
): T[] => {
  const selfHosted = isSelfHosted()
  const TAB_KEYS = TAB_KEYS_BY_PAGE.SETTINGS

  return items.filter((item, index) => {
    if (selfHosted) {
      if (item.key === TAB_KEYS[8]) return false
      if (item.key === TAB_KEYS[11] || items[index + 1]?.key === TAB_KEYS[11])
        return false
    }

    if (item.permission) return hasPermission(item.permission)

    return true
  })
}
